export const navbarBg = "navbar-theme";
export const sidenavBg = "sidenav-theme sidenav-dark";
export const footerBg = "footer-theme";
